import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { getPunchData, ProcessEmpLeave, ProcessPunch, PunchRecordsProcess } from "../../services/dataService";
import Loading from "../../components/common/Loading"; // Importing your Loading component
import Breadcrumb from "../../components/common/Breadcrumb";

function PunchProcess() {
  const UID = localStorage.getItem("userId");
  const [loading, setLoading] = useState(false); // Loader state

  const handleprocesspunch = async () => {
    if (loading) return; // Prevent multiple clicks
    setLoading(true); // Show loader

    const Data = { UserId: UID };

    try {
      const response = await ProcessPunch(Data);
      if (response) {
        toast.success("Processed successfully");
      }
    } catch (error) {
      toast.error("Failed to process");
    } finally {
      setLoading(false); // Hide loader
    }
  };



  const [puchdata, setPunchData] = useState([])

  const handlegetPuchData = async () => {
    const data = {
      UserId: UID,
      currentDate: new Date().toISOString().split('T')[0],
    };

    try {
      const resp = await getPunchData(data)
      setPunchData(resp.data.data)
      console.log(resp.data.data);

    } catch {
    }
  }

  useEffect(() => {
    console.log(puchdata);
    handlegetPuchData()
  }, [])

  const hasUnprocessedRecords = puchdata.some(el =>
    el.Processed == false && (el.Direction == 0 || el.Direction == 1)
  );


  useEffect(() => {
    console.log("hasUnprocessedRecords", hasUnprocessedRecords);

  }, [hasUnprocessedRecords])

  const handlepunchrecordsprocess = async () => {
    if (loading) return; // Prevent multiple clicks
    setLoading(true); // Show loader

    const data = { UserId: UID };

    try {
      const response = await PunchRecordsProcess(data);
      console.log(response, 'Response Log');

      console.log(hasUnprocessedRecords, 'dasasas');

      if (response) {
        toast.success("Processed Successfully");
        handlegetPuchData();
      }
    } catch (error) {
      console.error(error, 'Error occurred during processing');
      toast.error("An error occurred while processing the data");
    } finally {
      setLoading(false); // Hide loader
    }
  };


  // const handleProcessLeave = async () => {
  //   if (loading) return; // Prevent multiple clicks
  //   setLoading(true); // Show loader

  //   const data = { UserId: UID };

  //   try {
  //     const response = await ProcessEmpLeave(data);
  //     console.log(response, 'Response Log');

  //     console.log(hasUnprocessedRecords, 'dasasas');

  //     if (response) {
  //       toast.success("Processed Successfully");
  //     }
  //   } catch (error) {
  //     console.error(error, 'Error occurred during processing');
  //     toast.error("An error occurred while processing the data");
  //   } finally {
  //     setLoading(false); // Hide loader
  //   }
  // };
  return (
    <>
     <Breadcrumb title="" />
      <div className="flex min-h-screen bg-gray-100 p-4">
            

        <div className="flex flex-wrap gap-8 w-full justify-center">
          {/* Punch Records Button */}
          <div className="max-w-lg w-full relative">
            {/* Top-left text */}
            <p className="absolute top-0 left-0 text-gray-600 text-sm font-semibold">
              Click here to process punch records
            </p>

            <div className="bg-white shadow-lg rounded-2xl p-6 mt-6">
              <button
                onClick={handlepunchrecordsprocess}
                disabled={loading}
                className={`w-full py-2 px-4 bg-green-500 rounded-lg text-lg font-medium transition duration-300 
            ${loading ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"}`}
              >
                {loading ? "Processing..." : "Punch Records"}
              </button>
            </div>
          </div>

          {/* Process Leave Button */}
          {/* <div className="max-w-lg w-full relative">
      <p className="absolute top-0 left-0 text-gray-600 text-sm font-semibold">
        Click here to Process Employee Leave
      </p>

      <div className="bg-white shadow-lg rounded-2xl p-6 mt-6">
        <button
          onClick={handleProcessLeave}
          disabled={loading}
          className={`w-full py-2 px-4 bg-red-500 rounded-lg text-lg font-medium transition duration-300 
            ${loading ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"}`}
        >
          {loading ? "Processing..." : "Process Leave"}
        </button>
      </div>
    </div> */}
        </div>
      </div>
    </>
  );
}

export default PunchProcess;
